/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconTextBold(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4 1h3.997c1.142 0 2.194.318 2.976.969.797.662 1.254 1.625 1.254 2.773 0 1.147-.457 2.11-1.254 2.773l-.106.085c.165.085.323.18.473.284.952.663 1.539 1.692 1.539 3.046 0 1.351-.588 2.404-1.53 3.096-.915.673-2.118.974-3.352.974H4V1zm3.997 5.984c.876 0 1.563-.244 2.017-.622.44-.366.713-.899.713-1.62 0-.722-.274-1.255-.713-1.62C9.56 2.743 8.873 2.5 7.997 2.5H5.5v4.484h2.497zM5.5 8.484V13.5h2.497c1.013 0 1.876-.25 2.464-.682.563-.414.918-1.02.918-1.888 0-.865-.348-1.434-.896-1.815-.582-.405-1.446-.631-2.486-.631H5.5z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M7 4h4.637c1.307 0 2.525.364 3.435 1.122.93.774 1.462 1.898 1.462 3.229 0 1.3-.507 2.402-1.398 3.174.116.067.228.138.336.214 1.11.772 1.792 1.974 1.792 3.543 0 1.565-.683 2.792-1.777 3.596-1.06.78-2.444 1.122-3.85 1.122H7V4zm4.637 6.701c.952 0 1.683-.264 2.156-.659.454-.377.741-.929.741-1.691 0-.763-.287-1.314-.741-1.692C13.32 6.265 12.589 6 11.637 6H9v4.701h2.637zm-2.637 2V18h2.637c1.111 0 2.041-.274 2.665-.733.59-.433.962-1.066.962-1.985 0-.917-.364-1.505-.934-1.902-.616-.428-1.549-.679-2.693-.679H9z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTextBold is deprecated and will be archived soon. Use IconTextBold instead.
 */
export function Experimental__IconTextBold(props) {
  return /*#__PURE__*/React.createElement(IconTextBold, props);
}